import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Label } from "@/components/site/SectionHeading";

// Supersonic "featured festival" block: half image, half oversized text
export const FeaturedSplit = ({ image, label, top, bottom, text, children, cta, to, reverse = false, testId }) => (
  <section className="border-t border-white/10" data-testid={testId}>
    <div className={`grid grid-cols-1 lg:grid-cols-2 ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
      <div className="relative overflow-hidden min-h-[420px] lg:min-h-[720px] group">
        <img src={image} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
      </div>
      <div className="min-w-0 px-5 md:px-16 py-20 lg:py-28 flex flex-col justify-center bg-[hsl(var(--surface))]">
        <Label>{label}</Label>
        <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mt-4">
          <span className="block text-white">{top}</span>
          <span className="block text-primary pl-[10%]">{bottom}</span>
        </h2>
        <p className="text-zinc-300 text-base sm:text-lg leading-relaxed mt-8 max-w-xl">{text}</p>
        {children}
        <Link
          to={to}
          data-testid={`${testId}-cta`}
          className="self-start mt-10 inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200"
        >
          {cta} <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);
